'use strict';

import VZTcBaseCard from './VZTcBaseCard';

/**
 * @class VZTcUsers
 * @extends VZTcBaseCard
 * @description Handles the Teams Calling users card with quantity selection functionality
 */
export default class VZTcUsers extends VZTcBaseCard {
    /**
     * @function initializeQuantitySelector
     * @description Sets up the quantity selector event listeners
     */
    initializeQuantitySelector() {
        this.quantitySelector = this.querySelector('.js-tc-user-quantity-input');

        if (this.quantitySelector) {
            this.boundQuantityChange = this.onQuantityChange.bind(this);
            this.quantitySelector.addEventListener('fieldUpdated', this.boundQuantityChange);
        }
    }

    /**
     * @function connectedCallback
     * @description Sets up the card and quantity selector event listeners
     */
    connectedCallback() {
        super.initializeCard();
        this.initializeQuantitySelector();

        // Listen for content updates to reattach event listeners
        this.boundContentUpdated = this.onContentUpdated.bind(this);
        this.productCard.addEventListener('teamscalling:contentupdated', this.boundContentUpdated);
    }

    /**
     * @function onContentUpdated
     * @description Reinitializes event listeners after content update
     */
    onContentUpdated() {
        this.initializeQuantitySelector();
    }

    /**
     * @function disconnectedCallback
     * @description Removes event listeners when element is removed from the DOM
     */
    disconnectedCallback() {
        super.disconnectedCallback();

        if (this.quantitySelector) {
            this.quantitySelector.removeEventListener('fieldUpdated', this.boundQuantityChange);
        }

        if (this.productCard) {
            this.productCard.removeEventListener('contentUpdated', this.boundContentUpdated);
        }
    }

    /**
     * @function onQuantityChange
     * @description Handles quantity changes, updates configuration and enables/disables the next card
     * @param {CustomEvent} evt - The fieldUpdated event from the quantity selector
     */
    onQuantityChange(evt) {
        const quantity = parseInt(evt.target.value, 10);

        // Update configuration and content
        this.updateConfig('usersQty', this.questionId, quantity.toString());
    }
}

if (!window.customElements.get('vz-tc-users')) {
    window.customElements.define('vz-tc-users', VZTcUsers);
}
